import React from 'utils/react';

import Header from 'components/Header';
import Layout from 'components/Layout';

import Panel from './Panel';
import { useEffect } from 'react';
import debug from 'utils/debug';

const D2 = debug('p:Geofences');

const Geofences = (props) => {
  const { projectId, fetchGeofences, geofences } = props;

  useEffect(() => {
    D2.S.INFO('useEffect', { props });

    if (projectId || !geofences) {
      fetchGeofences();
    }
  }, [projectId]);

  return (
    <Layout>
      <Header isLogo={false} isShadow />
      <Panel />
    </Layout>
  );
};
export default React.memo(Geofences);
